/**
 * GlassCard — the arcade glass panel used across all study / detail pages.
 * Wraps `glass-card` + scanline + dotmatrix overlays so individual pages
 * don't repeat the className soup.
 */
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
  /** Tailwind padding shorthand applied to the inner content layer. */
  padding?: string;
  /** Whether to render the dot-matrix grid overlay. Default true. */
  dotmatrix?: boolean;
}

export function GlassCard({
  children,
  className = '',
  padding = 'p-8 md:p-10',
  dotmatrix = true,
}: Props): JSX.Element {
  return (
    <div className={`rounded-3xl glass-card relative overflow-hidden ${padding} ${className}`}>
      {dotmatrix && <div className="absolute inset-0 bg-dotmatrix opacity-25 pointer-events-none" />}
      <div className="relative">{children}</div>
    </div>
  );
}
